const humanizeKey = (key) =>
  String(key)
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/[_-]+/g, " ")
    .replace(/^./, (character) => character.toUpperCase());

export const formatResolvedValue = (value) => {
  if (value === null || value === undefined || value === "") return "";

  if (Array.isArray(value)) {
    return value
      .map(formatResolvedValue)
      .filter(Boolean)
      .join(", ");
  }

  if (typeof value !== "object") return String(value);

  if (value.name) {
    const name = formatResolvedValue(value.name);
    const country = formatResolvedValue(value.country);
    return country ? `${name} (${country})` : name;
  }

  if (Object.prototype.hasOwnProperty.call(value, "value")) {
    return formatResolvedValue(value.value);
  }

  return Object.entries(value)
    .map(([key, entryValue]) => {
      const formattedValue = formatResolvedValue(entryValue);
      return formattedValue ? `${humanizeKey(key)}: ${formattedValue}` : "";
    })
    .filter(Boolean)
    .join(", ");
};
